import type { IntegrationRequestFormSchema } from '../../../../models/IntegrationRequest';
import CheckboxListField, { type CheckboxOption } from './CheckboxListField';
import type { Control } from 'react-hook-form';
import { FormCheckbox } from '@/components';
import FormSection from './FormSection';

interface BranchesSectionProps {
  control: Control<IntegrationRequestFormSchema>;
  branchOptions: CheckboxOption[];
  allBranches: boolean;
  disabled: boolean;
}

const BranchesSection = ({
  control,
  branchOptions,
  allBranches,
  disabled,
}: BranchesSectionProps) => (
  <FormSection title='Sucursales'>
    <FormCheckbox
      control={control}
      name='allBranches'
      placeholder='Todas las sucursales del comercio'
      disabled={disabled}
    />
    {!allBranches && (
      <CheckboxListField
        control={control}
        name='branchIds'
        options={branchOptions}
        disabled={disabled}
        emptyMessage='El comercio no tiene sucursales.'
      />
    )}
  </FormSection>
);

export default BranchesSection;
